module.exports = __webpack_public_path__ + "img/com-gyl.9cd251ee.png";